module.exports = __webpack_public_path__ + "assets/bb6daf0c3cce5226f07d097d8d302fa0.png";